var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMetaFeatureNameIsArray)?_vm._t("default",null,null,_vm.metaByProp):_vm._t("default",null,{"meta":_vm.metaByProp})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }